import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

export const Route = createFileRoute("/auth/microsoft/callback")({
  component: MicrosoftAuthCallback,
});

function MicrosoftAuthCallback() {
  const sentRef = useRef(false);

  useEffect(() => {
    if (sentRef.current) return;
    const code = new URLSearchParams(window.location.search).get("code");

    if (code && window.opener) {
      sentRef.current = true;
      window.opener.postMessage(
        { type: "microsoft-auth-callback", code },
        window.location.origin,
      );
      window.close();
    }
  }, []);

  return <p>Signing in...</p>;
}
